
import { getAllContainer } from "@/service/container.service";
import { getStationNames } from "@/service/station.service";
import {
  postSamplingPoint,
  getSamplingPointById,
  getSamplingPointsList,
  putSamplingPoint,
  postSamplingPointLabelling,
  getSamplingPointLabelling,
} from "@/service/samplingpoint.service";
import { IdName } from "@/types";
import { Container } from "@/types/container.type";
import { Station } from "@/types/station.type";
import { defineComponent, ref } from "@vue/runtime-core";
import { ElForm, ElRow } from "element-plus";
import { AppError } from "@/types/app.type";
import ParameterDialogComponent from "../parameter/parameterDialog.component.vue";
import ParameterDialogComponentClient from "../parameter/parameterDialogClient.component.vue";
import ColourDialogComponent from "../colour/colourDialog.component.vue";
import { SamplingPoint, SamplingPointLabelling } from "@/types/samplingpoint.type";
import { Filter } from "@/types/filter.type";
import {
  getCamerasConfigurationByStationId,
  updateCameraModelStation,
} from "@/service/cameraConfiguration.service";
import { CameraConfiguration, ProcessingTime } from "@/types/cameraconfiguration.type";
import { Tmoa } from "@/types/tmoa.type";
import { getTmoa, updateTmoa, uploadTmoaImage } from "@/service/tmoa.service";
import { sortByType } from "@/utils/tmoa.util";
import { ElMessage } from "element-plus";
import { User } from "@/types/user.type";
import { getUserPage } from "@/service/user.service";
import { getImageTmoa } from "@/service/image.service";
import { getReportsBySamplingPointId, postReport, putReport } from "@/service/report.service";
import type { Report } from "@/types/report.type";
import { getParameterList } from "@/service/parameter.service";
import { Parameter } from "@/types/parameter.type";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { RootState } from "@/types/state.type";
import TmoaInfoDialog from "@/components/samplingPoints/TmoaInfoDialog.component.vue";

const errorMessage = "error.required";

export interface TmoaLocal extends Tmoa {
  rawFile?: File;
  fileName?: string;
}

export default defineComponent({
  components: {
    ParameterDialogComponent,
    ColourDialogComponent,
    ElRow,
    ParameterDialogComponentClient,
    TmoaInfoDialog,
  },
  props: {
    id: {
      type: Number,
      required: false,
    },
  },
  setup() {
    const processingTime = ref<ProcessingTime>();

    const colorOptions = [
      // Colores por defecto
      "#67B7DC",
      "#6794DC",
      "#6771DC",
      "#8067DC",
      "#A367DC",
      "#C767DC",
      "#DC67CE",
      "#D667DC",
      "#E167DC",
      "#F167DC",

      // Amarillos
      "#F2E5A0",
      "#E8D98B",
      "#D9C87A",

      // Verdes
      "#A6B88F",
      "#8FA67A",
      "#768F63",
      "#6B7F58",

      // Marrones
      "#C2A27A",
      "#A88963",
      "#8B6F4E",

      // Azules
      "#A7B6C9",
      "#8FA1B5",
      "#768A9A",

      // Turquesa
      "#88A8A0",
      "#72948C",

      // Grises
      "#C7C7C2",
      "#B3B3AE",
      "#9A9A95",

      // Ocres
      "#B8A97A",
      "#9E8E6A",

      // Anomalía
      "#F37878",
    ];

    const router = useRouter();
    const store = useStore<RootState>();
    return { processingTime, colorOptions, router, store };
  },
  data() {
    return {
      station: {} as Station,
      camerasConfiguration: [] as Array<CameraConfiguration>,
      containers: [] as Container[],
      stations: [] as IdName[],
      samplingPointForm: {} as SamplingPoint,
      samplingPointLabel: {} as SamplingPointLabelling,
      tmoas: [] as TmoaLocal[],
      selectedSamplingPointTmoas: [] as Tmoa[],
      selectedSamplingPoint: 0,
      disableNumTmoa: false,
      showParameters: false,
      showColour: false,
      showCamera: false,
      showTmoas: false,
      showParametersClient: false,
      activeModel: false,
      throughModel: false,
      switchSamplintPointType: false,
      sequence: 1,
      minBlack: 0,
      maxWhite: 0,
      labellingScript: "new",
      modify: false,
      options: [
        { label: "Nuevo", value: true },
        { label: "Antiguo", value: false },
      ],
      hemisphereList: [
        { label: "N", name: "north" },
        { label: "S", name: "south" },
      ],
      rules: {
        name: [
          {
            required: true,
            message: this.$t(errorMessage),
            trigger: "blur",
          },
        ],
        hemisphere: [
          {
            required: true,
            message: this.$t(errorMessage),
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: this.$t(errorMessage),
            trigger: "blur",
          },
        ],
        typeDischarge: [
          {
            required: true,
            message: this.$t(errorMessage),
            trigger: "blur",
          },
        ],
        utmX: [
          {
            required: true,
            message: this.$t(errorMessage),
            trigger: "blur",
          },
        ],
        utmY: [
          {
            required: true,
            message: this.$t(errorMessage),
            trigger: "blur",
          },
        ],
        timeZone: [
          {
            required: true,
            message: this.$t(errorMessage),
            trigger: "blur",
          },
        ],
        container: [
          {
            required: true,
            message: this.$t(errorMessage),
            trigger: "blur",
          },
        ],
        samplingPointType: [
          {
            required: true,
            message: this.$t(errorMessage),
            trigger: "blur",
          },
        ],
      },
      users: [] as User[],
      popupContent: "",
      showPopup: false,
      showReport: false,
      reports: [] as Report[],
      showReportForm: false,
      editingReport: false,

      currentReport: {
        name: "",
        frequency: 0,
        mails: [],
        active: true,
        samplingPointId: null,
      } as unknown as Report,

      reportRules: {
        name: [{ required: true, message: "Nombre obligatorio", trigger: "blur" }],
        frequency: [{ required: true, message: "Selecciona frecuencia", trigger: "change" }],
      },
      parameters: [] as Parameter[],
      nameModified: false,
    };
  },
  async mounted() {
    if (this.id) {
      this.selectedSamplingPoint = this.id;
      this.samplingPointForm = await getSamplingPointById(this.id);
      this.samplingPointLabel =
        (await getSamplingPointLabelling(this.id)) || ({} as SamplingPointLabelling);
      this.station = this.samplingPointForm.station as Station;
      if (this.station !== null && this.station.id !== undefined) {
        this.camerasConfiguration = await getCamerasConfigurationByStationId(this.station.id);
      }
      this.modify = true;
    } else {
      this.samplingPointForm = {} as SamplingPoint;
      this.samplingPointForm.hasAllParameters = true;
      this.samplingPointForm.parameters = [];
      this.samplingPointForm.parametersClient = [];
      this.samplingPointForm.minBlack = 59; //Default
      this.samplingPointForm.maxWhite = 220; //Default
      this.samplingPointForm.labellingScript = "new"; //Default
      this.samplingPointForm.throughModel = false; //Default
    }
    this.samplingPointForm.visible = true;
    // this.containers = await getContainerNames();
    this.containers = await getAllContainer();
    this.stations = await getStationNames();
    this.stations.sort((a, b) => (a.name ?? "").localeCompare(b.name ?? ""));
    this.tmoas = await getTmoa();

    this.tmoas.forEach((tmoa) => {
      if (tmoa.file && !tmoa.fileName) {
        tmoa.fileName = this.getFilename(tmoa.file) || "";
      }
    });
    let colorIndex = 0;

    this.tmoas.forEach((tmoa) => {
      const sp = tmoa.samplingPoint as unknown as SamplingPoint;
      if (sp.id === this.id) {
        if (!tmoa.color) {
          tmoa.color = this.colorOptions[colorIndex];
          colorIndex++;
        }
      }
    });

    this.tmoas = sortByType(this.tmoas);
    this.users = (await getUserPage(0, 200)).data;
    this.users = this.users.filter((user: any) => {
      return (
        user.active === true &&
        user.aquacorpMember === "Member" &&
        [".bio", ".cv"].some((e) => user.email.includes(e))
      );
    });

    if (this.samplingPointForm.numTmoa && this.samplingPointForm.numTmoa > 0) {
      this.disableNumTmoa = true;
    }
  },
  methods: {
    openPopup(file: string) {
      getImageTmoa(file).then((res) => {
        this.popupContent = res;
      });
      this.showPopup = true;
    },
    openPopupReport() {
      this.showReport = true;
      this.loadReports();
    },
    getFilename(path: string): string | null {
      const parts = path.split("/");
      if (parts.length <= 3) return null;
      return parts.slice(3).join("/");
    },
    async loadReports() {
      const res = await getReportsBySamplingPointId(this.selectedSamplingPoint);
      this.reports = res;
      const response = await getParameterList();
      this.parameters = response.data;
    },
    getDefaultReportName(frequency: number) {
      let freqText = "";
      switch (frequency) {
        case 1:
          freqText = "Diario";
          break;
        case 7:
          freqText = "Semanal";
          break;
        case 30:
          freqText = "Mensual";
          break;
        default:
          freqText = "Personalizado";
      }

      const samplingPointName = this.samplingPointForm.name || "Punto de monitorización";
      const email = this.store.state.auth.user?.email || "";
      const username = email.split("@")[0];

      return `${samplingPointName} (${username}) - Informe automático ${freqText}`;
    },
    onFrequencyChange(newFreq: number) {
      this.currentReport.frequency = newFreq;
      if (!this.nameModified) {
        this.currentReport.name = this.getDefaultReportName(newFreq);
      }
    },

    onNameInput() {
      this.nameModified = true;
    },
    createNewReport() {
      this.editingReport = false;

      this.currentReport = {
        name: this.getDefaultReportName(30),
        frequency: 30,
        mails: [],
        active: true,
        samplingPointId: this.selectedSamplingPoint,
      };

      this.showReportForm = true;
    },
    editReport(report: Report) {
      this.editingReport = true;

      this.currentReport = {
        id: report.id,
        name: report.name,
        frequency: report.frequency,
        mails: [...report.mails],
        active: report.active,
        samplingPointId: report.samplingPointId,
      };

      this.showReportForm = true;
    },
    cancelReport() {
      this.showReportForm = false;
    },
    async saveReport() {
      const formRef = this.$refs["reportForm"] as InstanceType<typeof ElForm>;
      const valid = await formRef.validate();
      if (!valid) return;

      try {
        if (this.editingReport) {
          // EDITAR
          await putReport(this.currentReport.id!, this.currentReport);
          ElMessage.success("Informe actualizado");
        } else {
          // CREAR
          const { id, lastSendDate, lastSendStatus, ...data } = this.currentReport;
          await postReport(data);
          ElMessage.success("Informe creado");
        }

        this.showReportForm = false;
        this.loadReports();
      } catch (err) {
        ElMessage.error("Error guardando el informe");
      }
    },
    async doSave(): Promise<SamplingPoint> {
      const valid = await (this.$refs["form"] as InstanceType<typeof ElForm>).validate();
      if (!valid) {
        throw new Error(AppError.FORM_VALIDATION);
      }
      let samplingPoint;
      if (this.samplingPointForm.id === undefined) {
        samplingPoint = await postSamplingPoint(this.samplingPointForm);
      } else {
        this.samplingPointForm.yBright = this.samplingPointForm.yBright
          ? this.samplingPointForm.yBright
          : undefined;
        this.samplingPointForm.xBright = this.samplingPointForm.xBright
          ? this.samplingPointForm.xBright
          : undefined;
        this.samplingPointForm.dyBright = this.samplingPointForm.dyBright
          ? this.samplingPointForm.dyBright
          : undefined;
        this.samplingPointForm.dxBright = this.samplingPointForm.dxBright
          ? this.samplingPointForm.dxBright
          : undefined;

        this.samplingPointLabel.samplingPointId = await getSamplingPointById(
          this.samplingPointForm.id
        );

        await postSamplingPointLabelling(this.samplingPointLabel);

        samplingPoint = await putSamplingPoint(this.samplingPointForm);
      }

      return samplingPoint;
    },
    changeCamera(camera: CameraConfiguration) {
      if (!camera.modele) {
        camera.imageProcessingTime = undefined;
      }
    },
    ckeckCamera(camera: CameraConfiguration) {
      let processTime = [] as string[];
      if (camera?.imageProcessingTime) {
        this.camerasConfiguration.forEach((_) => {
          if (_?.imageProcessingTime) {
            if (_?.imageProcessingTime && !processTime.includes(_?.imageProcessingTime)) {
              if (
                (_?.imageProcessingTime === "ALL_DAY" &&
                  (processTime.includes("DAY") || processTime.includes("NIGHT"))) ||
                ((_?.imageProcessingTime === "DAY" || _?.imageProcessingTime === "NIGHT") &&
                  processTime.includes("ALL_DAY"))
              ) {
                ElMessage.warning(this.$t("warning.confNotAllowed"));
                camera.imageProcessingTime = undefined;
              } else {
                processTime.push(_?.imageProcessingTime);
              }
            } else {
              ElMessage.warning(this.$t("warning.confProcessingTime"));
              camera.imageProcessingTime = undefined;
            }
          }
        });
      }
    },
    async updateCamerasModelStation(cameras: CameraConfiguration[]) {
      // Comprobación de que este completado correctamente
      let canConfiguration = true;
      cameras.forEach(async (camera) => {
        if (camera.modele && !camera.imageProcessingTime && camera.camera?.name) {
          ElMessage.warning(this.$t("warning.confNotCorrectTime", { code: camera.camera.name }));
          canConfiguration = false;
        }
      });
      if (canConfiguration) {
        cameras.forEach(async (camera) => {
          await updateCameraModelStation(
            camera.id as number,
            camera.modele as boolean,
            camera.station?.id as number,
            camera.imageProcessingTime
          );
        });
        this.showCamera = false;
      }
    },
    // updateTmoas() {
    //   this.tmoas.forEach(async (tmoa) => {
    //     await updateTmoa(tmoa.id, tmoa.name, tmoa.value);
    //   });
    //   this.showTmoas = false;
    // },
    async updateTmoas() {
      try {
        const pointTmoas = this.tmoas.filter(
          (tmoa) => (tmoa.samplingPoint as unknown as SamplingPoint).id === this.id
        );

        const colors = pointTmoas.map((t) => t.color);
        const uniqueColors = new Set(colors);

        if (uniqueColors.size !== colors.length) {
          ElMessage.warning("No se puede guardar, hay colores repetidos");
          return;
        }

        const stationCode = (this.samplingPointForm.station as Station)?.station || "";

        const uploadPromises = this.tmoas.map(async (tmoa) => {
          if (tmoa.rawFile) {
            const res = await uploadTmoaImage(stationCode, tmoa.rawFile);
            tmoa.file = res.data.url;
          }
          return tmoa;
        });

        await Promise.all(uploadPromises);

        const updatePromises = this.tmoas.map((tmoa) =>
          updateTmoa(tmoa.id, tmoa.name, tmoa.value, tmoa.file, tmoa.color)
        );

        await Promise.all(updatePromises);

        ElMessage.success("TMOAs actualizados correctamente");
        this.showTmoas = false;
      } catch (err) {
        // console.error(err);
        ElMessage.error("Error actualizando TMOAs");
      }
    },
    openDialogParameter() {
      this.showParameters = true;
    },
    openDialogParameterClient() {
      this.showParametersClient = true;
    },
    // openDialogColour() {
    //   this.showColour = true;
    // },
    openDialogCamera() {
      this.showCamera = true;
    },
    openDialogTmoas() {
      this.showTmoas = true;
    },
    saveParameters() {
      const checkedAll = (
        this.$refs["parameterDialog"] as InstanceType<typeof ParameterDialogComponent>
      ).getCheckedAll();
      const selectedParameters = (
        this.$refs["parameterDialog"] as InstanceType<typeof ParameterDialogComponent>
      ).saveParameter();

      this.samplingPointForm.hasAllParameters = checkedAll;
      this.samplingPointForm.parameters = selectedParameters;

      this.showParameters = false;

      return this.samplingPointForm.parameters;
    },
    saveParametersClient() {
      const selectedParametersClient = (
        this.$refs["parameterDialog"] as InstanceType<typeof ParameterDialogComponentClient>
      ).saveParameter();

      this.samplingPointForm.parametersClient = selectedParametersClient;

      this.showParametersClient = false;

      return this.samplingPointForm.parametersClient;
    },

    saveCodeFromChild() {
      const colourDialog = this.$refs.colourDialog as typeof ColourDialogComponent | undefined;
      if (colourDialog) {
        const colours = colourDialog.colours;

        if (colours) {
          for (const colour of colours) {
            colourDialog.saveCode(colour);
          }
        }
      }
      this.showColour = false;
    },
    /**
     * close samplingPoint formDialog
     */
    closeEntityDialog() {
      this.showParameters = false;
      this.showParametersClient = false;
      this.showColour = false;
      this.showCamera = false;
      this.showTmoas = false;
    },
    async checkSamplintPointType() {
      if (this.samplingPointForm.container) {
        if (
          this.samplingPointForm.container.containerType?.samplingPointType !== undefined &&
          this.samplingPointForm.container.containerType?.samplingPointType.length > 0
        ) {
          this.switchSamplintPointType = true;
          this.makesequence();
        } else {
          this.makesequence();
          this.switchSamplintPointType = false;
        }
      } else {
        this.makesequence();
        this.switchSamplintPointType = false;
      }
      this.containers = await getAllContainer();
      if (this.samplingPointForm.samplingPointType) {
        this.samplingPointForm.samplingPointType = undefined;
        this.makesequence();
      }
    },
    async makesequence() {
      this.sequence = 1;
      if (
        this.switchSamplintPointType &&
        this.samplingPointForm.samplingPointType &&
        this.samplingPointForm.samplingPointType.name
      ) {
        const filter: Filter = {
          fields: {
            "samplingPoint.containerId": {
              operator: "equal",
              value: this.samplingPointForm.container?.id,
            },
            "samplingPointType.name": {
              operator: "equal",
              value: this.samplingPointForm.samplingPointType.name,
            },
          },
        };
        const listaSamplinpoint = await getSamplingPointsList(
          undefined,
          undefined,
          filter,
          undefined
        );
        this.sequence = listaSamplinpoint.data.length + 1;
        this.makeName();
        this.makeCode();
      } else {
        this.sequence = 1;
        const filter: Filter = {
          fields: {
            "samplingPoint.containerId": {
              operator: "equal",
              value: this.samplingPointForm.container?.id,
            },
          },
        };
        const listaSamplinpoint = await getSamplingPointsList(
          undefined,
          undefined,
          filter,
          undefined
        );
        this.sequence = listaSamplinpoint.data.length + 1;
        this.makeName();
        this.makeCode();
      }
    },
    makeName() {
      let containerName: string | undefined = "";
      let samplingPointType: string | undefined = "";
      let sequence = this.sequence == 1 ? "" : this.sequence;
      if (this.samplingPointForm.container?.name) {
        if (this.switchSamplintPointType && this.samplingPointForm.samplingPointType) {
          containerName = this.samplingPointForm.container?.name.trim();
          samplingPointType = this.samplingPointForm.samplingPointType.name?.trim();
          if (sequence >= 2) {
            this.samplingPointForm.name = `${containerName} ${samplingPointType} ${sequence}`;
          } else {
            this.samplingPointForm.name = `${containerName} ${samplingPointType}`;
          }
        } else {
          containerName = this.samplingPointForm.container?.name.trim();
          if (sequence >= 2) {
            this.samplingPointForm.name = `${containerName} ${sequence}`;
          } else {
            this.samplingPointForm.name = `${containerName}`;
          }
        }
      }
    },

    //Crear el código del punto
    makeCode() {
      let typeSamplingPoint: string | undefined = "";
      let sequence = this.sequence == 1 ? "" : this.sequence;

      if (this.switchSamplintPointType) {
        let name = this.getTypeAndLocality(this.samplingPointForm.container as Container);

        if (
          this.samplingPointForm.samplingPointType !== undefined &&
          this.samplingPointForm.samplingPointType.name !== undefined
        ) {
          typeSamplingPoint = this.samplingPointForm.samplingPointType?.name
            .trim()
            .replace(/\s+/g, " ")
            .split(" ")
            .map((word) => word.substring(0, 3))
            .join("_")
            .toLocaleUpperCase();
        }

        if (sequence >= 2) {
          this.samplingPointForm.code = `${name}_${typeSamplingPoint}_${sequence}`;
        } else {
          this.samplingPointForm.code = `${name}_${typeSamplingPoint}`;
        }
      } else {
        let name = this.getTypeAndLocality(this.samplingPointForm.container as Container);

        if (sequence >= 2) {
          this.samplingPointForm.code = `${name}_${sequence}`;
        } else {
          this.samplingPointForm.code = `${name}`;
        }
      }

      let noAccents = this.removeAccents(this.samplingPointForm.code);
      this.samplingPointForm.code = noAccents;
    },

    //Obtener contenedor y localidad para el código
    getTypeAndLocality(container: Container) {
      let typeContainer: string | undefined = "";
      let location: string | undefined = "";

      // Contenedor completo
      typeContainer =
        container.containerType?.name !== undefined
          ? container.containerType?.name.trim().replace(/\s+/g, "").toLocaleUpperCase()
          : "";

      if (container) {
        // sin artículos
        const ignoredWords = ["el", "la", "los", "las", "un", "una", "unos", "unas", "de", "del"];

        // Dividir por palabras
        const words = container.locality
          ?.trim()
          .replace(/\s+/g, " ")
          .split(" ")
          .filter((word) => word.length > 2 && !ignoredWords.includes(word.toLowerCase())); // Elimina palabras de 2 letras y artículos

        if (words && words.length > 0) {
          // 1º palabra, 4 letras
          location = words[0].substring(0, 4).toLocaleUpperCase();

          // primeras 3 letras de las siguientes palabras
          for (let i = 1; i < words.length; i++) {
            location += "_" + words[i].substring(0, 3).toLocaleUpperCase();
          }
        }
      }
      return typeContainer + "_" + location;
    },
    removeAccents(string: string) {
      var mapAccents: any = {
        á: "a",
        é: "e",
        í: "i",
        ó: "o",
        ú: "u",
        Á: "A",
        É: "E",
        Í: "I",
        Ó: "O",
        Ú: "U",
      };
      return string.replace(/[áéíóúÁÉÍÓÚ]/g, function (letter: string) {
        return mapAccents[letter];
      });
    },
    handleImageUpload(file: { raw: File }, index: number) {
      if (!file.raw) return;

      const maxSize = 50 * 1024; // 50 KB
      if (file.raw.size > maxSize) {
        ElMessage.error("La imagen debe pesar menos de 50 KB");
        return;
      }

      this.tmoas[index].rawFile = file.raw;
      this.tmoas[index].fileName = file.raw.name;

      const reader = new FileReader();
      reader.onload = (e) => {
        this.tmoas[index].file = e.target?.result as string;
      };
      reader.readAsDataURL(file.raw);
    },

    removeImage(index: number) {
      this.tmoas[index].file = undefined;
      this.tmoas[index].rawFile = undefined;
    },
  },
  watch: {
    tmoas: {
      deep: true,
      handler(newTmoas) {
        newTmoas.forEach((tmoa: { color: string }) => {
          if (!tmoa.color) {
            tmoa.color = "#FFFFFF";
          }
        });
      },
    },
  },
});
